import type { PhotoMaterialType, ScheduleType } from "@/api/schedule/models";
import type { ClosingLocationEnum } from "@/enums/talent";
import type { PaginationResponse } from "@/interfaces/api";

export enum PhotoLabTalentStatusEnum {
  WAITING_MATERIAL = "WAITING_MATERIAL",
  READY_FOR_CASTING = "READY_FOR_CASTING",
}

export const PhotoLabTalentStatusLabel: Record<PhotoLabTalentStatusEnum, string> = {
  [PhotoLabTalentStatusEnum.WAITING_MATERIAL]: "Aguardando material",
  [PhotoLabTalentStatusEnum.READY_FOR_CASTING]: "Pronto para Casting",
};

export interface PhotoLabTalentDetail {
  id: string;
  talentId: string;
  talentCode: string | null;
  fullName: string;
  birthday: string;
  age: string;
  genderIdentity?: string | null;
  closingLocation: ClosingLocationEnum;
  status: PhotoLabTalentStatusEnum;
  enteredAt: string;
  readyForCastingAt?: string | null;
  profilePhotoUrl: string | null;
}

export interface PhotoLabTalent {
  id: string;
  talentId: string;
  talentCode: string | null;
  fullName: string;
  age: string;
  birthday?: string | null;
  genderIdentity?: string | null;
  entryType?: ScheduleType | null;
  producerName?: string | null;
  closingDate?: string | null;
  closingLocation: ClosingLocationEnum;
  material?: PhotoMaterialType | null;
  status: PhotoLabTalentStatusEnum;
  enteredAt: string;
  readyForCastingAt?: string | null;
  profilePhotoUrl?: string | null;
}

export interface PhotoLabProducer {
  id: string;
  name: string;
}

export type SearchPhotoLabTalentsResponse = PaginationResponse<PhotoLabTalent>;

export interface UpdatePhotoLabTalentStatusResponse {
  id: string;
  talentId: string;
  status: PhotoLabTalentStatusEnum;
  readyForCastingAt?: string | null;
}

export interface PhotoLabPhoto {
  id: string;
  url: string;
  originalName: string;
  mimeType: string;
  sizeBytes: number;
  isMain: boolean;
  createdDate?: string;
  createdBy?: { id: string; name?: string | null; fullName?: string | null } | null;
}

export interface PhotoLabPhotoListResponse {
  data: PhotoLabPhoto[];
  total: number;
  page: number;
  limit: number;
  pageCount: number;
}
